import moment from "moment";
import { FC, useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { getEnrolledStudentSummary } from "../../../api/statistics.api";
import useAxios from "../../../hooks/useAxios";
import { IGetEnrolledStudentSummary } from "../../../models/statistics.model";
import { RootState } from "../../../store/rootReducer";
import ErrorResponse from "../../ErrorResponse";
import Loader from "../../Loader";

interface IProps {
  semesterCode: number|undefined;
}

const StudentChart: FC<IProps> = ({
  semesterCode,
}) => {
  const { t } = useTranslation();
  const { serverDate } = useSelector((state: RootState) => state.serverDate);
  const { data: res, isLoading, error, execute } = useAxios<IGetEnrolledStudentSummary>();

  const [s1Count, setS1Count] = useState<number>();
  const [s2Count, setS2Count] = useState<number>();

  useEffect(() => {
    if (semesterCode && serverDate) {
      execute(getEnrolledStudentSummary({
        semesterCode,
        date: moment(serverDate).subtract(1, 'days').format('YYYYMMDD'),
      }));
    }
  }, [semesterCode, serverDate]);

  useEffect(() => {
    if (res && !isLoading) {
      //setS1Count(res.data.reduce((acc: number, cur: any) => acc + cur.s1Count, 0));
      //setS2Count(res.data.reduce((acc: number, cur: any) => acc + cur.s2Count, 0));
      setS1Count(30);
      setS2Count(50);
    }
  }, [res, isLoading]);

  return (
    <>
      {isLoading && <Loader />}
      <ErrorResponse error={error} />

      <div className="flex flex-justify-center">
        {(s1Count !== undefined && s2Count !== undefined) && (
          <Chart
            type="pie"
            options={{
              labels: [`${t('class.dashboard.column4')} (${s1Count})`, `${t('class.dashboard.column5')} (${s2Count})`],
              legend: { position: 'bottom', fontFamily: 'Roboto'},
              dataLabels: {
                style: {
                  colors: ['#ffffff'],
                  fontFamily: 'Roboto'
                },
                background: {
                  enabled: true,
                  borderWidth: 1,
                  opacity: 1,
                  foreColor: '#000000',
                  borderColor: '#000000',
                  dropShadow: { enabled: false },
                },
                dropShadow: { enabled: false },
                formatter(val: string | number | number[], opts?: any): any {
                  return [
                    `${Number(val)?.toFixed(1)}%`,
                    `${opts.seriesIndex === 0 ? s1Count : s2Count} ${t('dashboard.text.6')}`,
                  ];
                }
              },
              colors: ["#8bd0db","#cde9ee"],
              states: {
                hover: {
                  filter: {
                    type: 'none'
                  }
                }
              },
              tooltip: {
                fillSeriesColor: false
              },

            }}
            series={[s1Count, s2Count]}
          />
        )}
      </div>
    </>
  );
}

export default StudentChart;
